/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 *
 * @param {Function} clearFormErrors
 * @param {Function} clearReduxDataErrors
 */
export const handleClearError = (clearFormErrors, clearReduxDataErrors) => {
  if (clearFormErrors) {
    clearFormErrors();
  }
  if (clearReduxDataErrors) {
    clearReduxDataErrors();
  }
};

/**
 * Again the dataError comes from our ReduxDialog HOC and the error comes from the ReduxForm HOC so we have to clear both
 * @param {String} dataError
 * @param {Object} error
 * @param {Function} formatMessage
 */
export const determineDialogError = (dataError, error, formatMessage) => {
  const translatedDataError =
    !dataError || typeof dataError === 'string'
      ? dataError
      : formatMessage(dataError.i18nMessage, dataError.values);
  const translatedError =
    !error || typeof error === 'string' ? error : formatMessage(error.i18nMessage, error.values);
  return translatedDataError || translatedError;
};
